import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id 95E70948-C85D-41AC-887C-62752FBA7B6B
 * name bowl-mix
 * version: 1.6.50
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/bowl-mix.svg
 * tags
 * - Food / Drink 
 */
export const BowlMixIcon = createSvgIcon(<><path d="M16.2 11L20.3 4.5L22 5.5L18.6 11H16.2M15.6 12H2V15C2 18.9 5.1 22 9 22H15C18.9 22 22 18.9 22 15V12H15.6Z" /></>, 'BowlMixIcon');
export default BowlMixIcon